import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SubscriptSizing } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import {
  LocationService,
  AccountLocation,
} from '@common/services/location.service';

@Component({
  selector: 'pl-location-select',
  templateUrl: './pl-location-select.component.html',
  styleUrls: ['./pl-location-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PlLocationSelectComponent),
    },
  ],
})
export class PlLocationSelectComponent implements ControlValueAccessor {
  @Input() label = 'Location';

  @Input() multiple = false;

  @Input() placeholder = 'Select location';

  @Input() subscriptSizing: SubscriptSizing = 'fixed';

  disabled = false;

  value: string | string[] | null = null;

  locations$: Observable<AccountLocation[]> =
    this.locationService.getLocations();

  onChange: (value: string | string[] | null) => void = () => {};

  onTouched: () => void = () => {};

  constructor(
    private locationService: LocationService,
    private cdRef: ChangeDetectorRef
  ) {}

  writeValue(value: string | string[] | null): void {
    this.value = this.multiple ? value || [] : value;
    this.cdRef.markForCheck();
  }

  registerOnChange(fn: (value: string | string[] | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdRef.markForCheck();
  }

  onSelectionChange(value: string | string[] | null): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
